import React from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { fonts } from "theme/fonts";

import playIcon from "Images/play-button.png";

export const Header = ({
  headerTitles,
  headerShowLogo,
  headerLogo,
  headerBgImage,
  headerRegistration = false,
  headerSecondaryText,
  headerCTA,
}) => {
  return (
    <HeaderWrapper as="header">
      {headerRegistration ? (
        <>
          <HeaderFill />
          <HeaderBackground headerBgImage={headerBgImage}>
            <HeaderContainer>
              {headerShowLogo && <HeaderLogo src={headerLogo} />}
              {headerTitles && (
                <HeaderTitles>{ReactHtmlParser(headerTitles)}</HeaderTitles>
              )}
              {headerCTA && (
                <HeaderCTA
                  href="https://www.youtube.com/watch?v=lDToOe8pVzY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="header__cta">
                    {headerCTA}
                    <PlayIcon src={playIcon} />
                  </div>
                </HeaderCTA>
              )}
            </HeaderContainer>
          </HeaderBackground>
        </>
      ) : (
        <>
          <SecondaryHeaderContainer headerShowLogo={headerShowLogo}>
            {headerShowLogo && <SecondaryHeaderLogo src={headerLogo} />}
            <SecondaryHeader>
              {ReactHtmlParser(headerSecondaryText)}
            </SecondaryHeader>
          </SecondaryHeaderContainer>
        </>
      )}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.header`
  background: #102b4e;
  z-index: 1;
  display: flex;
  flex-direction: row;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    z-index: unset;
  }
`;

const HeaderFill = styled.div`
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    min-width: 490px;
  }
`;

const HeaderBackground = styled.div`
  background-image: url('${(props) => props.headerBgImage}');
  background-size: cover;
  background-position: top right;
  flex-grow: 1;
`;

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px 15px;
  position: relative;
  background: linear-gradient(
    60deg,
    rgba(16, 43, 78, 1) 35%,
    rgba(16, 43, 78, 0.5) 65%,
    rgba(16, 43, 78, 0) 85%
  );

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    justify-content: flex-start;
    padding: 30px;
  }
`;

const HeaderLogo = styled.img`
  width: 100%;
`;

const HeaderTitles = styled.div`
  color: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: ${fonts.brandLight};

  p {
    margin: 0;
  }

  strong {
    font-family: ${fonts.brandBold};
  }

  .headerTitle__presents {
    font-size: 2.5vw;

    @media only screen and ${(props) => props.theme.maxMedia.medium} {
      font-size: 16px;
    }
  }

  .headerTitle__artist {
    font-family: ${fonts.brandBold};
    font-size: 5vw;

    @media only screen and ${(props) => props.theme.maxMedia.medium} {
      font-size: 32px;
    }
  }

  .headerTitle__series {
    font-size: 4vw;

    @media only screen and ${(props) => props.theme.maxMedia.medium} {
      font-size: 25px;
    }
  }
`;

const HeaderCTA = styled.a`
  .header__cta {
    color: #ffffff;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    overflow: hidden;
    z-index: 0;
    padding: 5px 15px 5px 30px;
    font-size: 10px;

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgb(69 128 221 / 75%);
      transform-origin: 0 100%;
      transform: skew(-45deg);
      z-index: -1;
    }

    @media only screen and ${(props) => props.theme.maxMedia.small} {
      font-size: 12px;
    }

    @media only screen and ${(props) => props.theme.maxMedia.medium} {
      padding: 5px 15px 5px 35px;
      font-size: 14px;
    }
  }
`;

const PlayIcon = styled.img`
  width: 100%;
  max-width: 20px;
  margin-left: 8px;
`;

const SecondaryHeaderContainer = styled.div`
  padding: 25px 15px;
  width: 100%;
  text-align: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: ${(props) =>
      props.headerShowLogo ? "35px 15px 35px 180px" : "35px 15px"};
  }
`;

const SecondaryHeaderLogo = styled.img`
  width: 100%;
  max-width: 150px;
  position: absolute;
  top: 0;
  left: 15px;
  display: none;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: block;
    z-index: 1;
  }
`;

const SecondaryHeader = styled.h2`
  color: #ffffff;
  font-family: ${fonts.brandLight};
  margin: 0;
  text-transform: uppercase;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 30px;
  }

  span {
    font-family: ${fonts.brandBold};
  }
`;

const ModalLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }
`;
